// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__owkq1","errorLogs":"EditorFooter_errorLogs__3aeMl"};